export function isTransparentColor(color) {
  if (!color || color === "transparent" || color === "none") {
    return true;
  }
  const match = String(color).match(/^rgba?\(([^)]*)\)/i);
  if (match) {
    const parts = match[1].split(",").map(part => part.trim());
    if (parts.length === 4) {
      return Number(parts[3]) === 0;
    }
  }
  return false;
}

export function resolveCompletionTrackColor(configuredColor, fillColor) {
  if (!isTransparentColor(configuredColor)) {
    return configuredColor;
  }
  if (isTransparentColor(fillColor)) {
    return configuredColor;
  }
  return `color-mix(in srgb, ${fillColor} 25%, transparent)`;
}
